(function() {
  function applyRing(v) {
    if (!v) return;
    v = v.trim();
    document.querySelectorAll('.oph-colors__swatch').forEach(function(s) {
      s.classList.remove('is-active');
      if ((s.getAttribute('data-color-value') || s.getAttribute('data-tooltip')) === v) {
        s.classList.add('is-active');
      }
    });
    var sp = document.getElementById('selected-Color');
    if (sp) sp.textContent = v;
  }

  function fromSrc(src) {
    if (!src) return;
    var f = src.split('/').pop().split('?')[0].toLowerCase();
    document.querySelectorAll('.oph-colors__swatch').forEach(function(s) {
      var c = s.getAttribute('data-color-value') || s.getAttribute('data-tooltip') || '';
      if (c && f.includes(c.toLowerCase().replace(/\s+/g, '-'))) applyRing(c);
    });
  }

  document.addEventListener('click', function(e) {
    // Foundation page thumbnails
    var t = e.target.closest('.oph-media__thumb');
    if (t) {
      var src = t.getAttribute('src') || t.src;
      if (src) { setTimeout(function(){ fromSrc(src); }, 150); return; }
    }
    // Eyeshadow/standard page thumbnails
    var btn = e.target.closest('button.thumbnail');
    if (btn) {
      var img = btn.querySelector('img');
      if (img) {
        var src = img.getAttribute('src') || img.src;
        if (src) setTimeout(function(){ fromSrc(src); }, 150);
      }
    }
  });
})();